import Endpoint from './const/Endpoint';
import HttpService from '../http/HttpService';
import AclPrivilege from './const/AclPrivilege';

const aclModules = new Map();

async function getAcl(module) {
  if (aclModules.has(module)) {
    return aclModules.get(module);
  }

  const data = HttpService.post(Endpoint.GET_ACL, module);
  aclModules.set(module, data);

  return data;
}

export async function canCreate(module) {
  const { data } = await getAcl(module);
  return data[AclPrivilege.CREATE] === undefined ? false : data[AclPrivilege.CREATE];
}

export async function canView(module) {
  const { data } = await getAcl(module);
  return data[AclPrivilege.VIEW] === undefined ? false : data[AclPrivilege.VIEW];
}

export async function canDelete(module) {
  const { data } = await getAcl(module);
  return data[AclPrivilege.DELETE] === undefined ? false : data[AclPrivilege.DELETE];
}

export async function canUpdate(module) {
  const { data } = await getAcl(module);
  return data[AclPrivilege.UPDATE] === undefined ? false : data[AclPrivilege.UPDATE];
}
